const VOLUME_KEY = 'ttm.localVolume';
const MUTED_KEY = 'ttm.localMuted';
const CHANGE_EVENT = 'ttm-local-volume';
export const VOLUME_GESTURE_EVENT = 'ttm-volume-gesture';

export type LocalAudio = { volume: number; muted: boolean };

function clampVolume(value: number): number {
  if (!Number.isFinite(value)) return 100;
  return Math.max(0, Math.min(100, Math.round(value)));
}

export function loadLocalVolume(): LocalAudio {
  try {
    const rawVolume = window.localStorage.getItem(VOLUME_KEY);
    const rawMuted = window.localStorage.getItem(MUTED_KEY);
    const volume = clampVolume(rawVolume == null ? 100 : Number(rawVolume));
    const muted = rawMuted === '1' || rawMuted === 'true';
    return { volume, muted };
  } catch {
    return { volume: 100, muted: false };
  }
}

export function saveLocalVolume(volume: number, muted: boolean): void {
  try {
    window.localStorage.setItem(VOLUME_KEY, String(clampVolume(volume)));
    window.localStorage.setItem(MUTED_KEY, muted ? '1' : '0');
  } catch {
    // ignore quota / private mode
  }
}

export function publishLocalAudio(next: LocalAudio): LocalAudio {
  const audio = { volume: clampVolume(next.volume), muted: next.muted };
  saveLocalVolume(audio.volume, audio.muted);
  window.dispatchEvent(new CustomEvent<LocalAudio>(CHANGE_EVENT, { detail: audio }));
  return audio;
}

export function subscribeLocalAudio(listener: (audio: LocalAudio) => void): () => void {
  const handler = (event: Event) => {
    const detail = (event as CustomEvent<LocalAudio>).detail;
    if (detail) listener(detail);
  };
  window.addEventListener(CHANGE_EVENT, handler);
  return () => window.removeEventListener(CHANGE_EVENT, handler);
}

export function notifyVolumeGesture(): void {
  window.dispatchEvent(new Event(VOLUME_GESTURE_EVENT));
}

export function applyLocalAudio(
  player: YT.Player | null,
  volume: number,
  muted: boolean,
): void {
  if (!player) return;
  try {
    const level = clampVolume(volume);
    player.setVolume(level);
    if (muted || level === 0) player.mute();
    else player.unMute();
  } catch {
    // ignore
  }
}
